import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

import { api, getLegacySessionId } from "@/lib/api";
import { useSession } from "@/contexts/SessionContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH (per Emergent Google Auth playbook).

export default function AuthCallback() {
    const navigate = useNavigate();
    const { hydrateAfterLogin } = useSession();
    const processed = useRef(false);
    const [stage, setStage] = useState("Exchanging credentials…");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        (async () => {
            try {
                const fragment = (window.location.hash || "").replace(/^#/, "");
                const params = new URLSearchParams(fragment);
                const session_id = params.get("session_id");
                if (!session_id) {
                    toast.error("No session_id in URL fragment");
                    navigate("/", { replace: true });
                    return;
                }
                await api.post("/auth/session", { session_id });

                // Hydrate user/profile/vault inside the React tree
                setStage("Loading workspace…");
                const user = await hydrateAfterLogin();

                // If we have a legacy anonymous session_id sitting in
                // localStorage, the LegacyClaimBanner will handle the offer.
                // We just clean the URL fragment + route to home.
                window.history.replaceState(
                    {},
                    document.title,
                    window.location.pathname
                );
                if (user) {
                    toast.success(`Welcome, ${user.name?.split(" ")[0] || ""}`);
                }
                navigate("/", { replace: true });
            } catch (err) {
                const msg =
                    err?.response?.data?.detail || err?.message || "Sign-in failed";
                toast.error("Sign-in failed", { description: String(msg) });
                navigate("/", { replace: true });
            }
        })();
    }, [hydrateAfterLogin, navigate]);

    return (
        <div className="flex min-h-screen items-center justify-center bg-[#0B0F19] text-[#E8ECF5]">
            <div className="flex flex-col items-center gap-3">
                <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#1F2A40] border-t-[#00F5D4]" />
                <span
                    className="font-mono text-xs uppercase tracking-[0.32em] text-[#8A93A6]"
                    data-testid="auth-callback-stage"
                >
                    {stage}
                </span>
            </div>
        </div>
    );
}
